export type ErrorResponse = {
    errors: string[];
}

export function isErrorResponse(result: any): result is ErrorResponse {
    if (result?.errors == null) {
        return false;
    }
    return Array.isArray(result.errors);
}